/* eslint-disable max-len */
/**
 * @file 下载中心路由
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';
import { Loading } from '@tencent/ptp-fe-common';
import loadable from '@loadable/component';

export default [
  {
    label: '下载中心',
    // href: '/agency/download/index',
    // target: '_blank',
    key: 'download',
    desc: '管理下载任务',
    hide: true,
    data: [
      {
        label: '下载中心',
        href: '/agency/download/index',
        path: '/agency/download/:type',
        hide: true,
        data: [
          {
            // 支持跨越式显示第三级菜单
            label: '服务商下载中心',
            href: '/agency/download/index',
            purview: 21000,
            component: loadable(() => import(/* webpackChunkName: 'download' */ /* webpackMode: 'lazy' */ '@/pages/agency/download/Layout'), { fallback: <Loading /> }),
            basePage: true,
          },
          {
            label: '日报下载中心',
            href: '/agency/download/dailyreport',
            purview: 1111,
            component: loadable(() => import(/* webpackChunkName: 'download' */ /* webpackMode: 'lazy' */ '@/pages/agency/download/daily-report'), { fallback: <Loading /> }),
            basePage: true,
          },
        ],
      },
    ],
  },
];
